import type { BuiltinSymbolId, SymbolGraphic } from './model';

import { builtinArtwork } from './builtin/artwork';
export interface BuiltinSymbol {
  readonly id: BuiltinSymbolId;
  readonly name: string;
  readonly keywords: string;
  readonly defaultAnchor: 'center' | 'bottom';
  readonly tintable: true;
  readonly svg: string;
  readonly source: 'Maki' | 'Temaki';
}
const entries = [
  ['pin', 'Map pin', 'location place marker', 'marker'],
  ['flag', 'Flag', 'destination embassy', 'embassy'],
  ['information', 'Information', 'help visitor', 'information'],
  ['star', 'Star', 'favourite highlight', 'star'],
  ['bus', 'Bus stop', 'transport transit road', 'bus'],
  ['rail', 'Train station', 'rail railway transport', 'rail'],
  ['metro', 'Metro / subway', 'underground transport rail', 'rail-metro'],
  ['tram', 'Tram / light rail', 'streetcar transport', 'rail-light'],
  ['ferry', 'Ferry terminal', 'boat ship water transport', 'ferry'],
  ['bicycle', 'Bicycle', 'bike cycle transport', 'bicycle'],
  ['parking', 'Parking', 'car transport', 'parking'],
  ['airport', 'Airport', 'plane flight transport', 'airport'],
  ['school', 'School / education', 'community learning', 'school'],
  ['hospital', 'Hospital / health', 'medical community', 'hospital'],
  ['park', 'Park / open space', 'tree nature recreation', 'park'],
  ['construction', 'Construction / development', 'planning works', 'construction'],
  ['walking', 'Walking / pedestrian', 'walk foot transport', 'pedestrian'],
  ['library', 'Library', 'books community', 'library'],
] as const;
/** Original upstream files, locally bundled. See builtin/README.md for pinned provenance. */
export const BUILTIN_SYMBOLS: readonly BuiltinSymbol[] = entries.map(
  ([id, name, keywords, file]) => ({
    id: `placeio-v1:${id}`,
    name,
    keywords,
    defaultAnchor: id === 'pin' ? 'bottom' : 'center',
    tintable: true,
    svg: builtinArtwork[file]!,
    source: id === 'walking' ? 'Temaki' : 'Maki',
  }),
);
export function builtinSymbol(id: BuiltinSymbolId): BuiltinSymbol {
  const symbol = BUILTIN_SYMBOLS.find((entry) => entry.id === id);
  if (!symbol) throw new Error('This built-in symbol is unavailable.');
  return symbol;
}
export function graphicName(
  graphic: SymbolGraphic,
  assets: readonly { id: string; name: string }[],
): string {
  return typeof graphic === 'string'
    ? graphic[0]!.toUpperCase() + graphic.slice(1)
    : graphic.kind === 'builtin'
      ? builtinSymbol(graphic.id).name
      : (assets.find((a) => a.id === graphic.assetId)?.name ?? 'Unavailable symbol');
}
